module.exports = __webpack_public_path__ + "1bdd7d62d86d0cbc30f2526a4068446c.png";